import { render } from "./CustomerSegmentAll.vue?vue&type=template&id=512a1f91&scoped=true"
import script from "./CustomerSegmentAll.vue?vue&type=script&lang=js"
export * from "./CustomerSegmentAll.vue?vue&type=script&lang=js"

import "./CustomerSegmentAll.vue?vue&type=style&index=0&id=512a1f91&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html-prod/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-512a1f91"]])

export default __exports__